import * as Sentry from '@sentry/angular';
import {
  ApplicationConfig,
  provideZoneChangeDetection,
  inject,
  provideAppInitializer,
  ErrorHandler,
} from '@angular/core';
import {
  provideClientHydration,
  withEventReplay,
  withNoIncrementalHydration,
} from '@angular/platform-browser';
import { provideRouter, Router } from '@angular/router';
import {
  provideHttpClient,
  withInterceptors,
  withFetch,
} from '@angular/common/http';
import { IMAGE_LOADER } from '@angular/common';
import { routes } from './app.routes';
import { cloudinaryImageLoader } from './utils/image.loader';
import { authInterceptor } from './interceptors/auth.interceptor';
import { UserService } from './services/user.service';

import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { AppTranslateLoader } from './i18n/app-translate-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
    provideRouter(routes),
    {
      provide: IMAGE_LOADER,
      useValue: cloudinaryImageLoader,
    },
    provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
    provideTranslateService({
      fallbackLang: 'es',
      loader: { provide: TranslateLoader, useClass: AppTranslateLoader },
    }),
    provideAppInitializer(async () => {
      const userService = inject(UserService);
      try {
        await userService.initializeProfile();
      } catch {
        // App continúa aunque falle
      }
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
};
